import React, { useEffect } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import Switcher from "../components/switcher";
import VideoBackground from "../components/VideoBackground";
import CardBeneficios from "../components/CardBeneficios";
import cuadroL from "../assets/images/sidom/fotos/smartreader/cuadroL.svg";
import cuadroD from "../assets/images/sidom/fotos/smartreader/cuadroD.svg";
import GetInTuch from "../components/getInTuch";
import useStore from "../store/useStore";

const productos = [
  {
    title: "Flexibilidad",
    description:
      "Adaptación a los requerimientos de cada cliente, desarrollos con procesos ágiles que garantizan respuesta inmediata.",
  },
  {
    title: "Integración con ERPs",
    description:
      "Potencia ampliada al integrar la data de su sistema en la plataforma. Automatización que representa un importante retorno de inversión.",
  },
  {
    title: "Reportes y KPIs",
    description:
      "Información de sus operaciones a nivel internacional para una mejor toma de decisiones, integración con herramientas de Power BI.",
  },
  {
    title: "Workflow de aprobación",
    description:
      "Seteo de flujos de avance de procesos automático o bajo requerimiento de confirmación ante acciones críticas.",
  },
  {
    title: "Alertas y vencimientos",
    description:
      "Automatización del seguimiento de calendarios a través de seteo predeterminado o personalizado.",
  },
  {
    title: "Reducción de costos",
    description:
      "Eliminación de cargas manuales, data entry y errores de tipeo de factor humano determinan la reducción de multas y pérdidas de tiempo.",
  },
];
export default function SmartReader() {
  const { smartReaderHeroes, getSmartReaderHeroes } = useStore();
  const urlApi = "https://api.institucional.global.sidom.io";

  useEffect(() => {
    getSmartReaderHeroes();
  }, [getSmartReaderHeroes]);
  return (
    <>
      <div className=" bg-sidom-light dark:bg-sidom-blue ">
        <Navbar />
        <div>
          {smartReaderHeroes?.length === 0 || !smartReaderHeroes ? (
            <VideoBackground
              video="/placeholder.mp4"
              titulo1="Cargando..."
              titulo2="Espere un momento"
              textbutton="SOLICITAR DEMO"
              logo="/placeholder-logo.png"
            />
          ) : (
            smartReaderHeroes.map((item, index) => (
              <VideoBackground
                key={index}
                video={`${urlApi}${item.video[0]?.url}`}
                titulo1={item.titulo}
                titulo2={item.text}
                textbutton="SOLICITAR DEMO"
                logo={`${urlApi}${
                  item.img[0]?.formats?.thumbnail?.url ||
                  item.img?.url ||
                  "/placeholder-logo.png"
                }`}
              />
            ))
          )}
        </div>

        <div className=" container bg-sidom-light dark:bg-sidom-blue overflow-hidden  "></div>
        <div className="w-full aspect-video max-h-[200vh]   mb-8">
          <video
            controls
            autoPlay
            muted
            className="w-full h-full object-cover shadow-md"
          >
            <source
              src=" https://sidomsuite.com/wp-content/themes/sidom-pay/assets/SmartReader.mp4"
              type="video/webm"
            />
          </video>
        </div>
        <div className=" container flex flex-col text-xl   mb-[60px] text-left">
          <h3 className=" text-sidom-dark  dark:text-sidom-light text-4xl md:text-5xl font-extrabold text-left">
            ¿Qué es <strong className="text-sidom-orange">SIDOM</strong> Smart
            Reader?
          </h3>
        </div>
        <div className="w-full container   mt-[60px] leading-[1.3] flex justify-center">
          <div className=" text-left text-base md:text-lg leading-relaxed space-y-6 first-line:">
            <p>
              Es la solución definitiva para la centralización, validación y
              almacenamiento de toda la documentación de comercio exterior. Es
              la única plataforma 100% Cloud/SaaS del mercado que permite
              optimizar los tiempos operativos y otorgar
              <strong>COMPLIANCE</strong> a los procesos al convertir tareas
              manuales en un proceso automático
            </p>
          </div>
        </div>
        <div className=" mt-[100px] mb-[100px] flex bg-sidom-blue  flex-col w-full">
          <h2 className="text-sidom-orange container text-4xl md:text-5xl mt-[100px] font-extrabold text-left mb-[100px]">
            Beneficios
          </h2>
          <div className=" mb-[100px] ">
            {productos.map((producto, index) => (
              <CardBeneficios
                key={index}
                titulo={producto.title}
                descripcion={producto.description}
                backgroundColor={"bg-sidom-blue  "}
                textcolor={"text-sidom-light "}
              />
            ))}
          </div>
        </div>
        <h2 className="text-sidom-dark dark:text-sidom-light container text-4xl md:text-5xl font-extrabold text-left mb-[100px]">
          Comparativa entre proceso manual vs.{" "}
          <span className="text-sidom-orange">Smart Reader</span>
        </h2>
        <div className="container  relative flex flex-col items-center justify-center mt[-100px] mb-[100px] ">
          <img
            src={cuadroL}
            alt="Cuadro izquierdo"
            className="block dark:hidden w-full h-auto"
          />
          <img
            src={cuadroD}
            alt="Cuadro izquierdo"
            className="  hidden dark:block w-full h-auto"
          />
        </div>
      </div>
      <GetInTuch />
      <Footer />
      <Switcher />
    </>
  );
}
